<template>
    <breeze-authenticated-layout>
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                Others
            </h2>
        </template>

        <breeze-page :submenus="subMenus">
            <slot />
        </breeze-page>
    </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import BreezePage from '@/Components/Page'

export default {
    components: {
        BreezeAuthenticatedLayout,
        BreezePage,
    },
    data() {
        return {
            subMenus: [
                {
                    'title': 'Resources',
                    'active': route().current('others.resource.*') || route().current('others.resource-submission.*'),
                    'route': route('others.resource.list'),
                    'visible': this.isAdmin(),
                },
                {
                    'title': 'University Marking',
                    'active': route().current('others.university-marking.*'),
                    'route': route('others.university-marking.list'),
                    'visible': this.isAdmin(),
                },
            ],
        }
    },
    methods: {
        isAdmin() {
            const role = this.$page.props.auth.user.role;

            return role?.type === 'super' || role?.name === 'Super Admin';
        },
    },
}
</script>
